import { VsIcon, genVsIconBaseProps } from '../shared';

export const OriginalIcon: VsIcon = props => {
  return (
    <svg
      {...genVsIconBaseProps(props)}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5353 29.0193C22.8328 29.0193 21.2147 28.6527 19.7593 27.9948C25.1321 30.5053 28.8835 35.9054 29.0173 42.1958C33.0864 39.2845 35.7391 34.5185 35.7391 29.1326C35.7391 27.0346 35.3367 25.0313 34.6029 23.1935C32.5981 26.6764 28.8414 29.0193 24.5353 29.0193Z"
        fill="#FFB800"
      />
      <path
        d="M34.2127 22.296C33.9888 21.8203 33.7417 21.3578 33.4736 20.9091C32.5934 19.4352 31.4836 18.1142 30.1941 16.9959C30.191 16.9906 30.1857 16.9875 30.1804 16.9843C28.9242 15.8987 27.4972 15.0048 25.9454 14.3469C24.8077 13.8649 23.6025 13.5099 22.3478 13.3018C22.3457 13.3018 22.3436 13.3013 22.3409 13.3008C21.4792 13.1559 20.5937 13.0822 19.6898 13.0822C17.813 13.0822 16.0126 13.4035 14.3392 13.9966C13.9941 14.1167 13.656 14.25 13.3231 14.3954C13.0644 15.3572 12.9275 16.3685 12.9275 17.4115C12.9275 22.12 15.7303 26.1723 19.7594 27.9948C21.2147 28.6527 22.8329 29.0193 24.5353 29.0193C28.8415 29.0193 32.5977 26.6764 34.603 23.1935C34.4829 22.8891 34.3528 22.5899 34.2127 22.296Z"
        fill="#2B3084"
      />
      <path
        d="M28.4088 13.2255C28.4088 12.429 28.6001 11.6784 28.9398 11.0158C28.9688 10.9547 29.0009 10.8957 29.0362 10.8367C29.6667 9.71419 30.7302 8.86719 32.0018 8.52375C31.4134 8.02651 30.7745 7.59036 30.095 7.2169C28.4431 6.31564 26.55 5.80365 24.5362 5.80365C23.242 5.80365 21.9968 6.0154 20.8348 6.40677C20.8311 6.40782 20.8274 6.40888 20.8232 6.41046C17.501 7.52979 14.8536 10.1129 13.6416 13.3909C13.5215 13.719 13.4151 14.0535 13.324 14.3948C13.6569 14.2495 13.995 14.1157 14.3401 13.9961C16.0135 13.4024 17.8145 13.0817 19.6907 13.0817C20.5946 13.0817 21.4801 13.1559 22.3418 13.3003C22.3439 13.3003 22.346 13.3008 22.3487 13.3013C23.6034 13.5094 24.8086 13.8644 25.9463 14.3464C27.4981 15.0043 28.9251 15.8982 30.1813 16.9838C29.0994 16.0909 28.4094 14.7388 28.4094 13.2255H28.4088Z"
        fill="#DB0025"
      />
    </svg>
  );
};
